import { render, staticRenderFns } from "./deleteCardInBatches.vue?vue&type=template&id=86bcae4c&"
import script from "./deleteCardInBatches.vue?vue&type=script&lang=js&"
export * from "./deleteCardInBatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports